module.exports = __webpack_public_path__ + "static/media/article-when-you-fly.1bff5054.jpg";